import { render } from "./SsoManager.vue?vue&type=template&id=77b87512"
import script from "./SsoManager.vue?vue&type=script&lang=js"
export * from "./SsoManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__